import { useParams } from 'react-router-dom';

import { PageWrapper } from '@ingrid/luterkort-react';

import { useTemplateDetailsQuery } from '../queries';
import { Addresses } from './addresses';
import { BasicInformation } from './basic-information';
import { CarrierProduct } from './carrier-product';
import { Header } from './header';
import { Metadata } from './metadata';

export function DetailsPage() {
  const { id } = useParams();

  const template = useTemplateDetailsQuery({ id });

  return (
    <PageWrapper gap="lg" variant="center">
      <Header template={template} />
      <BasicInformation template={template} />
      <Addresses template={template} />
      <CarrierProduct template={template} />
      <Metadata template={template} />
    </PageWrapper>
  );
}
